import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { MEWS_COMMUNITY_URL } from '@mews-commander/constants';
import { createListItem } from '../../helpers';
import StyledSidebarLink from '../../StyledSidebarLink';

const mewsUniversityListItem = createListItem({
    textKey: TextKey.Community,
    iconName: IconName.MessagesPlural,
    isMainItem: true,
});

export const MewsCommunityMenuItem = () => (
    <StyledSidebarLink href={MEWS_COMMUNITY_URL} target="_blank">
        {mewsUniversityListItem}
    </StyledSidebarLink>
);
